// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m2Ju","question":"styles_question__1orOP","description":"styles_description__1zKJC"};